import { Controller } from 'stimulus';

export default class extends Controller {
    show(event) {
      this.element.removeAttribute('disabled')
      this.element.innerHTML == this.confirmMessage ? true : this.changeText(event)
    }
    
    // Private
    
      changeText(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        
        const originalText = this.element.innerHTML
        this.element.innerHTML = this.confirmMessage
        this.revertText(originalText)
      }
      
      revertText(originalText) {
        setTimeout(() => this.element.innerHTML = originalText, 3000);
      }
      
      get confirmMessage() {
        return this.data.get('message')
      }
    
}